
import { ArrowRight, Calculator, Wallet, TrendingUp, Star, Sparkles,  } from 'lucide-react';
import Smallscale from "../../Assets/Small scale Owner.png";
import retailer from "../../Assets/retailer.png";
import distributor from "../../Assets/Distributor.png"
import { Link } from 'react-router-dom';

const SmartSolutionsSection = () => {
    return (
        <div className="relative bg-[#FAFAFB] py-8 lg:py-10 overflow-hidden font-inter">

            
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none">
                <div className="absolute top-1/4 -left-20 w-[500px] h-[500px] bg-blue-100/40 rounded-full blur-[120px]" />
                <div className="absolute bottom-1/4 -right-20 w-[500px] h-[500px] bg-indigo-100/40 rounded-full blur-[120px]" />
            </div>

            <div className="relative max-w-7xl mx-auto px-6">


                <div className="text-center mb-28">
                    
                    <h2 className="font-spacegrotesk text-4xl md:text-5xl lg:text-6xl font-bold text-[#1A1A1A] leading-[1.1] mb-4 tracking-tight">
                        Smart Solutions for <span className="text-blue-600">Everyone</span>
                    </h2>
                    <p className="text-slate-500 text-lg md:text-xl max-w-2xl mx-auto font-medium leading-relaxed">
                        Whether you are a retailer, distributor, or a self-help group, we provide the tools to scale your financial growth.
                    </p>
                </div>

                <div className="space-y-48">

                   
                    <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">

                       
                        <div className="relative order-2 lg:order-1 flex justify-center">
                           
                            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] border-2 border-dashed border-slate-200 rounded-full animate-[spin_20s_linear_infinite] -z-10" />

                            
                            <div className="absolute -left-6 lg:-left-10 top-12 bg-white/80 backdrop-blur-xl rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.08)] p-6 z-20 animate-float border border-white">
                                <div className="flex items-center gap-4 mb-4">
                                    <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center text-white shadow-lg shadow-blue-200">
                                        <Wallet size={24} />
                                    </div>
                                    <div>
                                        <p className="text-xs text-slate-400 font-bold uppercase tracking-widest">Monthly Earnings</p>
                                        <p className="text-2xl font-black text-slate-900">₹25,850+</p>
                                    </div>
                                </div>
                                <div className="flex gap-1">
                                    {[1, 2, 3, 4, 5].map((s) => <Star key={s} size={14} className="fill-orange-400 text-orange-400" />)}
                                    <span className="text-[10px] text-slate-400 font-bold ml-2">TOP RATED</span>
                                </div>
                            </div>

                           
                            <div className="relative group">
                                <div className="absolute -inset-4 bg-gradient-to-tr from-blue-100 to-indigo-100 rounded-[3rem] blur-2xl opacity-50 group-hover:opacity-80 transition-opacity" />
                                <div className="relative w-[300px] lg:w-[340px] aspect-[9/18.5]  overflow-hidden">
                                    <img src={Smallscale} alt='Retailer Dashboard' className='h-full w-full object-cover rounded-[2rem]' />
                                </div>
                            </div>
                        </div>

                        
                        <div className="order-1 lg:order-2 space-y-7">
                            <h3 className="inline-block text-blue-600 font-spacegrotesk font-bold text-2xl px-4 py-1 bg-blue-50 rounded-lg">
                                Retailer
                            </h3>
                            <h4 className="text-3xl lg:text-4xl font-bold text-slate-900 font-spacegrotesk leading-tight">
                                Join with Bumppy and earn more than <span className="text-blue-600 underline decoration-blue-100 underline-offset-8">25,000 per month</span>
                            </h4>
                            <p className="text-slate-500 text-lg leading-relaxed font-medium">
                                Retailers have a chance to select different products and provide the best service to customers. No need of any investment or any working capital for start journey with Bumppy.
                            </p>

                            <div className="flex flex-wrap items-center gap-4 pt-6">
                               
                                <a
                                    href="https://dashboard.bumppy.com/register"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-3 bg-indigo-600 text-white px-8 md:px-10 py-4 rounded-2xl font-bold hover:bg-slate-900 transition-all duration-300 shadow-xl shadow-indigo-200 hover:-translate-y-1 active:scale-95"
                                >
                                    Join Bumppy <ArrowRight size={20} />
                                </a>

                               
                                <Link
                                    to="/product/income-calculator"
                                    className="inline-flex items-center gap-3 bg-white border-2 border-slate-200 text-slate-600 px-8 md:px-10 py-4 rounded-2xl font-bold hover:border-indigo-600 hover:text-indigo-600 transition-all duration-300 hover:-translate-y-1 active:scale-95 shadow-sm"
                                >
                                    <Calculator size={20} />
                                    <span>Income Calc</span>
                                </Link>
                            </div>
                        </div>
                    </div>

                  
                    <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">

                        
                        <div className="space-y-7">
                            <h3 className="inline-block text-indigo-600 font-spacegrotesk font-bold text-2xl px-4 py-1 bg-indigo-50 rounded-lg">
                                Distributor
                            </h3>
                            <h4 className="text-3xl lg:text-4xl font-bold text-slate-900 font-spacegrotesk leading-tight">
                                Start your journey as distributor and make more than <span className="text-indigo-600 underline decoration-indigo-100 underline-offset-8">50,000 in a month</span>
                            </h4>
                            <p className="text-slate-500 text-lg leading-relaxed font-medium">
                                You can earn more money through your distribution service using the Bumppy platform. No need to make physical effort.
                            </p>    
                        

                            <div className="flex flex-wrap items-center gap-4 pt-6">

                                <a
                                    href="https://dashboard.bumppy.com/register"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-3 bg-indigo-600 text-white px-8 md:px-10 py-4 rounded-2xl font-bold hover:bg-slate-900 transition-all duration-300 shadow-xl shadow-indigo-200 hover:-translate-y-1 active:scale-95"
                                >
                                    Join Bumppy <ArrowRight size={20} />
                                </a>


                                <Link
                                    to="/product/income-calculator"
                                    className="inline-flex items-center gap-3 bg-white border-2 border-slate-200 text-slate-600 px-8 md:px-10 py-4 rounded-2xl font-bold hover:border-indigo-600 hover:text-indigo-600 transition-all duration-300 hover:-translate-y-1 active:scale-95 shadow-sm"
                                >
                                    <Calculator size={20} />
                                    <span>Income Calc</span>
                                </Link>
                            </div>
                        </div>

                        
                        <div className="relative flex justify-center">
                            
                            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-indigo-100/30 rounded-full blur-[100px] -z-10" />

                            
                            <div className="relative group">
                                <div className="absolute -right-8 bottom-12 bg-white/90 backdrop-blur-md rounded-2xl shadow-[0_25px_60px_rgba(0,0,0,0.12)] p-5 z-20 border border-white animate-float" style={{ animationDelay: '1s' }}>
                                    <div className="flex items-center gap-3 mb-4">
                                        {/* Network/Growth Icon */}
                                        <div className="w-10 h-10 bg-indigo-600 rounded-lg flex items-center justify-center text-white shadow-lg shadow-indigo-200">
                                            <TrendingUp size={20} />
                                        </div>
                                        <div>
                                            <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest leading-none mb-1">Total Commission</p>
                                            <p className="text-xl font-black text-slate-900">₹50,000+</p>
                                        </div>
                                    </div>

                                    {/* Micro Transaction Visuals (Instead of just gray bars) */}
                                    <div className="space-y-2">
                                        <div className="flex items-center gap-2">
                                            <div className="w-2 h-2 rounded-full bg-emerald-500"></div>
                                            <div className="w-24 h-1.5 bg-slate-100 rounded-full"></div>
                                            <span className="text-[8px] font-bold text-slate-400">SUCCESS</span>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <div className="w-2 h-2 rounded-full bg-indigo-400"></div>
                                            <div className="w-16 h-1.5 bg-slate-100 rounded-full"></div>
                                            <span className="text-[8px] font-bold text-slate-400">NETWORK</span>
                                        </div>
                                    </div>

                                    <div className="mt-4 pt-3 border-t border-slate-50 flex items-center justify-between">
                                        <span className="text-[9px] font-bold text-indigo-600 uppercase">Passive Income Mode</span>
                                        <div className="flex -space-x-2">
                                            {[1, 2, 3].map(i => (
                                                <div key={i} className="w-5 h-5 rounded-full border-2 border-white bg-slate-200" />
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="w-[300px] lg:w-[340px] ">
                                    <div className="overflow-hidden rounded-[2.2rem] h-full bg-white">
                                        <img src={distributor} alt='Distributor Stats' className='h-full w-full object-cover group-hover:scale-105 transition-transform duration-700' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">

                       
                        <div className="relative order-2 lg:order-1 flex justify-center">
                            
                            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%] border-2 border-dashed border-slate-200 rounded-full animate-[spin_20s_linear_infinite] -z-10" />

                          
                            <div className="absolute -left-6 lg:-left-10 top-12 bg-white/80 backdrop-blur-xl rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.08)] p-6 z-20 animate-float border border-white">
                                <div className="flex items-center gap-4 mb-4">
                                    {/* Home/Business Icon for Small Scale Owners */}
                                    <div className="w-12 h-12 bg-emerald-500 rounded-xl flex items-center justify-center text-white shadow-lg shadow-emerald-100">
                                        <TrendingUp size={24} />
                                    </div>
                                    <div>
                                        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest leading-none mb-1">Owner Earnings</p>
                                        <p className="text-2xl font-black text-slate-900">₹15,000+</p>
                                    </div>
                                </div>

                                {/* Dynamic Tagline */}
                                <div className="flex items-center gap-2 px-3 py-1 bg-emerald-50 rounded-full border border-emerald-100">
                                    <Sparkles size={12} className="text-emerald-600" />
                                    <span className="text-[10px] text-emerald-700 font-bold uppercase tracking-tight">
                                        Growing Tribe Group
                                    </span>
                                </div>
                            </div>

                            
                            <div className="relative group">
                                <div className="absolute -inset-4 bg-gradient-to-tr from-blue-100 to-indigo-100 rounded-[3rem] blur-2xl opacity-50 group-hover:opacity-80 transition-opacity" />
                                <div className="relative w-[300px] lg:w-[340px] aspect-[9/18.5]  overflow-hidden">
                                    <img src={retailer} alt='Retailer Dashboard' className='h-full w-full object-cover rounded-[2rem]' />
                                </div>
                            </div>
                        </div>

                        <div className="order-1 lg:order-2 space-y-7">
                            <h3 className="inline-block text-blue-600 font-spacegrotesk font-bold text-2xl px-4 py-1 bg-blue-50 rounded-lg">
                                Small scale Owner
                            </h3>
                            <h4 className="text-3xl lg:text-4xl font-bold text-slate-900 font-spacegrotesk leading-tight">
                                Join a growing tribe groups who earn more than <br></br> <span className="text-blue-600 underline decoration-blue-100 underline-offset-8">15,000 per month with us</span>
                            </h4>
                            <p className="text-slate-500 text-lg leading-relaxed font-medium">
                                Grab the opportunity to run your own business, from the comforts of your home or shop and earn additional income.
                            </p>

                            <div className="flex flex-wrap items-center gap-4 pt-6">

                                <a
                                    href="https://dashboard.bumppy.com/register"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-3 bg-indigo-600 text-white px-8 md:px-10 py-4 rounded-2xl font-bold hover:bg-slate-900 transition-all duration-300 shadow-xl shadow-indigo-200 hover:-translate-y-1 active:scale-95"
                                >
                                    Join Bumppy <ArrowRight size={20} />
                                </a>


                                <Link
                                    to="/product/income-calculator"
                                    className="inline-flex items-center gap-3 bg-white border-2 border-slate-200 text-slate-600 px-8 md:px-10 py-4 rounded-2xl font-bold hover:border-indigo-600 hover:text-indigo-600 transition-all duration-300 hover:-translate-y-1 active:scale-95 shadow-sm"
                                >
                                    <Calculator size={20} />
                                    <span>Income Calc</span>
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

           
            <style>{`
                @keyframes float {
                    0%, 100% { transform: translateY(0px) rotate(0deg); }
                    50% { transform: translateY(-20px) rotate(1deg); }
                }
                .animate-float { animation: float 6s ease-in-out infinite; }
                
                /* Responsive adjustments for fonts */
                @media (max-width: 640px) {
                    .font-spacegrotesk { letter-spacing: -0.02em; }
                }
            `}</style>
        </div>
    );
};

export default SmartSolutionsSection;